// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/alert_history.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { User } from "./user_pb";

/**
 * @generated from message msh.resource.v1.AlertHistory
 */
export const AlertHistory = proto3.makeMessageType(
  "msh.resource.v1.AlertHistory",
  () => [
    { no: 1, name: "request", kind: "message", T: AlertHistory_AlertRequest },
    { no: 2, name: "ack", kind: "message", T: AlertHistory_AlertAck },
  ],
);

/**
 * @generated from message msh.resource.v1.AlertHistory.AlertRequest
 */
export const AlertHistory_AlertRequest = proto3.makeMessageType(
  "msh.resource.v1.AlertHistory.AlertRequest",
  () => [
    { no: 1, name: "alert_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "creation_time", kind: "message", T: Timestamp },
    { no: 4, name: "level", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "AlertHistory_AlertRequest"},
);

/**
 * @generated from message msh.resource.v1.AlertHistory.AlertAck
 */
export const AlertHistory_AlertAck = proto3.makeMessageType(
  "msh.resource.v1.AlertHistory.AlertAck",
  () => [
    { no: 1, name: "alert_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "creation_time", kind: "message", T: Timestamp },
  ],
  {localName: "AlertHistory_AlertAck"},
);

